// Keep the exterior mounting plane fixed; the inner face follows leaf thickness.
export function leafDimensions(config = {}) {
  const thicknessMm = config.thicknessMm ?? 60;
  if (!Number.isFinite(thicknessMm) || thicknessMm < 30 || thicknessMm > 100) {
    throw new Error('Leaf thickness must be 30–100 mm.');
  }
  const backMm = -52.5;
  return { thicknessMm, backMm, frontMm: backMm + thicknessMm };
}
